import { z } from "zod";
import { zStringId, zTimestamps } from "../../utils";
import { zUserSnippet } from "../users/user-snippet-resource";
import { TransactionStatusEnum, TransactionTypeEnum } from "./transaction-statics";

export const zTransaction = z.object({
  _id: zStringId(),
  amount: z.number(),
  refId: z.string(),
  currency: z.string(),
  source: z.string(),
  status: z.nativeEnum(TransactionStatusEnum),
  type: z.nativeEnum(TransactionTypeEnum),
  subject: z.string(),
  orderNumber: z.number().nullable(),
  orderId: zStringId().optional(),
  payerDoc: zUserSnippet.optional(),
  recipientDoc: zUserSnippet.optional(),
  userDoc: z.object({
    firstName: z.string(),
    lastName: z.string(),
    username: z.string(),
    email: z.string(),
  }),
  ...zTimestamps(),
});

export type Transaction = z.infer<typeof zTransaction>;
